import {verify} from '../../../assets/js/tools.js';
export default{
    name:'EditPassword',
    data(){
        var checkPassword = (rule, value, callback) => {
          // var x = /^([A-Za-z\d]|[@\$!%\*#\?&\.]){6,10}$/;
          if (!value) {
            return callback(new Error('密码不能为空'));
          }
          if(value.length<6||value.length>10){
            return callback(new Error('密码长度为6-10位'));
          }
          if(verify('password',value)){
              return callback();
          }else{
              return callback(new Error('密码格式为数字、字母、@$!%*#?&.'));
          }
        };
        return{
            form:{
              oldPassword:'',
              newPassword1:'',
              newPassword2:'',
              yzm:''
            },
            buttonLoading:false,
            buttonText:'发送验证码',
            rules: {
                oldPassword: [
                  { required: true, message: '请输入旧密码', trigger: 'blur' },
                ],
                newPassword1: [
                    { validator: checkPassword,  trigger: 'blur' },
                ],
                newPassword2: [
                  { validator: checkPassword,  trigger: 'blur' },
                ],
                yzm: [
                  { required: true, message: '请输入验证码', trigger: 'blur' },
                ],
                
              }
        }
    },
    methods:{
        submitForm(formName) {
            this.$refs[formName].validate((valid) => {
              if (valid) {
                if(this.form.newPassword1!=this.form.newPassword2){
                  this.$message.warning('两次密码输入不一致');
                  return;
                }
                var userId=this.cookie.get('userID');
                var body={
                  userId:userId,
                  yzm:this.form.yzm,
                  password:this.form.oldPassword,
                  newPassWord:this.form.newPassword1,
                };
                this.postForm(this.api.updatePassword,body).then(res=>{
                  if(res.result==200){
                    this.$message.success('修改成功');
                    this.routerToUrl('/home');
                  }
                }).catch(err=>{
                  this.$message.error(err.msg);
                });
              } else {
                return false;
              }
            });
        },
        getPasWordYzm(){
          var userId=this.cookie.get('userID');
          this.postForm(this.api.getPasWordYzm,{userId:userId}).then(res=>{
            if(res.result==200){
              this.countDown(60);
            }
          }).catch(err=>{
            this.$message.warning(err.msg);
          });
        },
        countDown (time) {
          if (time === 0) {
              this.buttonLoading = false;
              this.buttonText = "发送验证码";
              return;
          } else {
              this.buttonLoading = true;
              this.buttonText = time;
              time--;
          }
          setTimeout(()=> {
          this.countDown(time)
          }, 1000)
      },
    }
}